export default "__VITE_ASSET__CxN7LAAY__"